<template>
  <div v-if="count != 999" class="seat">
    <span :class="seatStatusClass">
      {{ seatName }}
      <span v-if="seatName == 'サルーン'">（{{ count }}ボックス)</span>
      <span v-else-if="seatName != '一般席'">（{{ count }}席)</span>
    </span>
  </div>
</template>

<script>
import { getSeatStatus } from "@/services/MFITT/methods/getSeatStatus";
import { SEAT_STATUS } from "@/lib/constants";

export default {
  name: "MFITTSeatVacant",
  props: {
    seatName: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
  },
  computed: {
    seatStatusClass() {
      const status = getSeatStatus(this.count, this.seatName);
      const classMap = {
        [SEAT_STATUS.FULL]: "seatsFull",
        [SEAT_STATUS.LIMITED]: "notManySeatsLeft",
        [SEAT_STATUS.AVAILABLE]: "seatsAvailable",
      };
      return classMap[status];
    },
  },
};
</script>

<style lang="scss" scoped>
.train-list .list-body .buttons .button .seat {
  display: block;
  padding: 0;
  margin: 0 0 8px;
}
.train-list .list-body .buttons .button .seat .status {
  display: inline-block;
  width: 14px;
  width: auto;
  padding: 0;
  margin: 10px 0 0;
}
.train-list .list-body .buttons .button .seat span.seatsAvailable,
.train-list .list-body .buttons .button .seat span.notManySeatsLeft,
.train-list .list-body .buttons .button .seat span.seatsFull {
  font-size: 13px;
  line-height: 13px;
  padding: 0;
}
.train-list .list-body .buttons .button .seat span.seatsAvailable::before,
.train-list .list-body .buttons .button .seat span.notManySeatsLeft::before,
.train-list .list-body .buttons .button .seat span.seatsFull::before {
  content: "";
  display: inline-block;
  width: 16px;
  height: 16px;
  margin: 0;
  padding: 0 6px 0 0;
}
.train-list .list-body .buttons .button .seat span.seatsAvailable::before {
  background: url("~@/assets/img/icon/svg/icon-yes.svg") no-repeat;
  background-position: 0 4px;
}
.train-list .list-body .buttons .button .seat span.notManySeatsLeft::before {
  background: url("~@/assets/img/icon/svg/icon-little.svg") no-repeat;
  background-position: 0 4px;
}
.train-list .list-body .buttons .button .seat span.seatsFull::before {
  background: url("~@/assets/img/icon/svg/icon-none.svg") no-repeat;
  background-position: 0 4px;
}
</style>
